import styled, { css } from 'styled-components';
import Icon from '@anwb/icon';
import { pxToRem } from '@anwb/style-utilities';
import { ANWBDefault } from '@anwb/theme';
import Typography from '@anwb/typography';
const DESKTOP_HEIGHT = 188;
const TABLET_HEIGHT = 200;
const ICON_TRANSFORM = `translateX(${pxToRem(3)});`;
/**
 * Block Link
 */
export const blockLinkStyles = () => css `
	text-decoration: none;
`;
export const BlockLink = styled.a `
	${blockLinkStyles}
`;
/**
 * Block Container
 */
export const blockContainerStyles = ({ theme, $variant, }) => css `
	border-radius: ${pxToRem(theme.borderRadius.m)};
	box-sizing: border-box;
	cursor: pointer;
	display: flex;
	gap: ${pxToRem(theme.spacing['200'])};
	padding: ${pxToRem(theme.spacing['300'])};

	@media (min-width: ${pxToRem(theme.viewportBreakpoint.sm)}) {
		height: ${pxToRem(TABLET_HEIGHT)};
	}

	@media (min-width: ${pxToRem(theme.viewportBreakpoint.md)}) {
		gap: ${pxToRem(theme.spacing['300'])};
		height: ${pxToRem(DESKTOP_HEIGHT)};
		padding: ${pxToRem(theme.spacing['400'])};
	}

	${BlockTitle}, ${BlockContent} {
		strong {
			font-weight: inherit;
		}
	}

	${$variant === 'primary' &&
    css `
		background: ${theme.colors.base.bgBlocksPrimary};

		&:hover {
			background: ${theme.colors.base.bgBlocksPrimaryHover};
			${BlockArrow} {
				transform: ${ICON_TRANSFORM};
			}
		}

		${BlockTitle}, ${BlockContent} {
			color: ${theme.colors.blanc.titleInverse};

			strong {
				color: ${theme.colors.highlight.textInteractiveOnDark};
			}
		}
	`}

	${$variant === 'secondary' &&
    css `
		background: ${theme.colors.extralight.bgBlocksSecondary};

		&:hover {
			background: ${theme.colors.light.bgBlocksSecondaryHover};
			${BlockArrow} {
				transform: ${ICON_TRANSFORM};
			}
		}

		${BlockTitle}, ${BlockContent} {
			strong {
				color: ${theme.name === ANWBDefault.name
        ? theme.colors.highlight.textInteractive
        : theme.colors.highlight.textInteractiveOnLight};
			}
		}
	`}
`;
export const BlockContainer = styled.div `
	${blockContainerStyles}
`;
/**
 * Block Title
 */
export const blockTitleStyles = ({ theme }) => css `
	align-items: start;
	display: flex;
	gap: ${pxToRem(theme.spacing['200'])};

	${theme.name !== ANWBDefault.name &&
    css `
		color: ${theme.colors.highlight.textInteractive};
	`};
`;
export const BlockTitle = styled(Typography).attrs(() => ({
    tagName: 'span',
})) `
	${blockTitleStyles}
`;
/**
 * Block Icon
 */
export const blockIconStyles = () => css `
	line-height: inherit;
`;
export const BlockIcon = styled(Icon) `
	${blockIconStyles}
`;
/**
 * Block Container Wrapper
 */
export const blockContainerWrapperStyles = ({ theme }) => css `
	display: flex;
	flex-direction: column;
	gap: ${pxToRem(theme.spacing['200'])};
`;
export const BlockContainerWrapper = styled.div `
	${blockContainerWrapperStyles}
`;
/**
 * Block Arrow
 */
export const blockArrowStyles = ({ theme, $variant, }) => css `
	color: ${$variant === 'primary'
    ? theme.colors.blanc.titleInverse
    : theme.colors.highlight.textInteractive};
	flex: 0 0 auto;
	align-self: flex-end;
	transition: transform ${theme.timing['300']}ms cubic-bezier(${theme.easings.default});
`;
export const BlockArrow = styled(Icon) `
	${blockArrowStyles}
`;
/**
 * Block Content
 */
export const blockContentStyles = ({ theme }) => css `
	// CORE-UI overwrite
	margin-bottom: 0;

	@media (min-width: ${pxToRem(theme.viewportBreakpoint.sm)}) {
		overflow: hidden;
		text-overflow: ellipsis;
		display: -webkit-box;
		-webkit-line-clamp: 5;
		-webkit-box-orient: vertical;
	}

	@media (min-width: ${pxToRem(theme.viewportBreakpoint.md)}) {
		-webkit-line-clamp: 3;
	}
`;
export const BlockContent = styled(Typography) `
	${blockContentStyles}
`;
//# sourceMappingURL=block.styled.js.map